import {Auth} from "types/auth"
import {StudentNotePanel} from "../StudentNotePanel"

type Props = {
    student?: Auth.DepartmentStudent
    departmentId?: number
    onClose?: () => void
}

export const NotePanel = (props: Props) => {
    const {student} = props

    return <StudentNotePanel user={student} isSidebarChat />
}
